import ActivityStore from './ActivityStore';
import IgBusinessStore from './IgBusinessStore';
import { action, computed, extendObservable } from 'mobx';
import { BMC_BLOCKS } from '../../common_components/bmc/bmc_constants';
import { stagesArray } from '../../common_components/bmc/bmc_functions';
import { LEAN_BLOCKS, TEMPLATES } from '../constants';
//import {businessBlocksArray} from "../functions";
import Template from '../models/TemplateModel';
import AuthorizationStore from './AuthorizationStore';

export default class RootStore {
  constructor({ currentUserPermission, userRoles }) {
    this.authorizationStore = new AuthorizationStore(
      this,
      currentUserPermission
    );
    this.activityStore = new ActivityStore(this);
    this.igBusinessStore = new IgBusinessStore(this, this.authorizationStore);

    this.initialBlock = BMC_BLOCKS.REVENUE_STREAMS;

    extendObservable(this, { pathPrefixRoute: 'igbusiness' });

    this.initTemplates();

    // CurrentUser must have a name and an array of roles
    currentUserPermission.user['roles'] = userRoles;
    this.user = currentUserPermission.user;
  }

  @computed get initialPath() {
    return `/${this.pathPrefixRoute}/activities/`;
  }

  @computed get editPathPrefix() {
    return `/${this.pathPrefixRoute}/activities/`;
  }

  @computed get newActivityPathPrefix() {
    return `/${this.pathPrefixRoute}/new/`;
  }

  initTemplates() {
    const stages = stagesArray();
    this.templates = {};
    for (const stage of stages) {
      this.templates[stage] = [];
      for (const key of Object.keys(TEMPLATES[stage])) {
        this.templates[stage].push(
          new Template(this, stage, key, TEMPLATES[stage][key])
        );
      }
    }
  }

  @computed get currentStageTemplates() {
    return this.templates[this.igBusinessStore.currentStage];
  }

  @computed get currentBlockStore() {
    return this.igBusinessStore.currentBlockStore;
  }

  // New activity navigation by blocks
  @action setCurrentBlock(block) {
    this.igBusinessStore.setCurrentBlock(block);
    const lastPreselected = this.activityStore.activityEdit.preselectedCard;
    this.activityStore.activityEdit.setPreselectedCard(undefined);
    if (lastPreselected && lastPreselected.preselected) {
      lastPreselected.preselected = false;
    }
  }

  @computed get loading() {
    return this.igBusinessStore.boardsLoading || this.activityStore.loading;
  }

  @action updatePathPrefix(newPrefix) {
    if (this.pathPrefixRoute !== newPrefix) this.pathPrefixRoute = newPrefix;
  }

  pathPrefix() {
    const editingActivityId = this.activityStore.activityEdit.id;
    const prefix = this.activityStore.isEditing
      ? this.initialPath + editingActivityId + '/edit/'
      : this.newActivityPathPrefix;
    return prefix;
  }

  blockPath(block) {
    return this.pathPrefix() + block;
  }

  @computed get newActivityPath() {
    return this.newActivityPathPrefix + BMC_BLOCKS.REVENUE_STREAMS;
  }

  // New and edit paths
  nextPath() {
    const nextMapping = {
      [BMC_BLOCKS.REVENUE_STREAMS]: LEAN_BLOCKS.MEASURE,
      [LEAN_BLOCKS.MEASURE]: BMC_BLOCKS.KEY_ACTIVITIES,
      [BMC_BLOCKS.KEY_ACTIVITIES]: BMC_BLOCKS.KEY_PROPOSITIONS,
      [BMC_BLOCKS.KEY_PROPOSITIONS]: BMC_BLOCKS.CUSTOMER_RELATIONSHIPS,
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: BMC_BLOCKS.CHANNELS,
      [BMC_BLOCKS.CHANNELS]: BMC_BLOCKS.CUSTOMER_SEGMENTS,
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: BMC_BLOCKS.KEY_RESOURCES,
      [BMC_BLOCKS.KEY_RESOURCES]: BMC_BLOCKS.KEY_PARTNERS,
      [BMC_BLOCKS.KEY_PARTNERS]: BMC_BLOCKS.COST_STRUCTURE,
      [BMC_BLOCKS.COST_STRUCTURE]: LEAN_BLOCKS.LEARN,
      [LEAN_BLOCKS.LEARN]: LEAN_BLOCKS.BUILD,
      [LEAN_BLOCKS.BUILD]: 'final_step'
    };

    const currentBlock = this.igBusinessStore.currentBlock;
    let nextBlock = nextMapping[currentBlock];
    if (!nextBlock) return undefined;

    return nextBlock === 'final_step'
      ? this.pathPrefix() + 'final_step'
      : this.blockPath(nextBlock);
  }

  // Implement prevPath similarly with check for learn/build steps
  prevPath() {
    const prevMapping = {
      [LEAN_BLOCKS.BUILD]: LEAN_BLOCKS.LEARN,
      [LEAN_BLOCKS.LEARN]: BMC_BLOCKS.COST_STRUCTURE,
      [BMC_BLOCKS.COST_STRUCTURE]: BMC_BLOCKS.KEY_PARTNERS,
      [BMC_BLOCKS.KEY_PARTNERS]: BMC_BLOCKS.KEY_RESOURCES,
      [BMC_BLOCKS.KEY_RESOURCES]: BMC_BLOCKS.CUSTOMER_SEGMENTS,
      [BMC_BLOCKS.CUSTOMER_SEGMENTS]: BMC_BLOCKS.CHANNELS,
      [BMC_BLOCKS.CHANNELS]: BMC_BLOCKS.CUSTOMER_RELATIONSHIPS,
      [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: BMC_BLOCKS.KEY_PROPOSITIONS,
      [BMC_BLOCKS.KEY_PROPOSITIONS]: BMC_BLOCKS.KEY_ACTIVITIES,
      [BMC_BLOCKS.KEY_ACTIVITIES]: LEAN_BLOCKS.MEASURE,
      [LEAN_BLOCKS.MEASURE]: BMC_BLOCKS.REVENUE_STREAMS,
      [BMC_BLOCKS.REVENUE_STREAMS]: undefined
    };

    const currentBlock = this.igBusinessStore.currentBlock;
    let prevBlock = prevMapping[currentBlock];
    if (!prevBlock) return undefined;

    // // Prevent accessing learn and build steps if not in edit mode
    // if (
    //   !this.activityStore.isEditing &&
    //   (prevBlock === LEAN_BLOCKS.LEARN || prevBlock === LEAN_BLOCKS.BUILD)
    // ) {
    //   return undefined;
    // }

    return this.blockPath(prevBlock);
  }

  getEditPath(activityId) {
    return this.editPathPrefix + activityId + '/edit/' + this.initialBlock;
  }

  @computed get disableLearnBuildBlocks() {
    return !this.activityStore.isEditing;
  }
}
